import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import AdminPanel from "./components/AdminPanel";
import FormularioStandard from "./components/FormularioStandard";
import FormularioSupervisor from "./components/FormularioSupervisor";

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/formulario" element={<FormularioStandard />} />
          <Route path="/supervisor" element={<FormularioSupervisor />} />
          <Route path="*" element={<Login />} />
        </Routes>
    </Router>
  );
}

export default App;
<Routes>
  <Route path="/login" element={<Login />} />
  <Route path="/admin" element={<AdminPanel />} />
  <Route path="/formulario" element={<FormularioStandard />} />
  <Route path="/supervisor" element={<FormularioSupervisor />} />
  <Route path="*" element={<Login />} />
</Routes>

